<template>
    <div class="columns is-multiline">
        <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="true"></b-loading>

        <div class="column is-full">
            <b-field label="Faqs visibles" message="Controla la visibilidad de la seccion de FAQs.">
                <b-switch
                @input="editBasicInfo"
                v-model="info.faqsFlag">
                </b-switch>
            </b-field>
        </div>

        <div v-for="item in faqs" :key="item.id" class="column is-half">
            <div class="card">
                <div class="card-content">
                    <b-field>
                        <a
                        class="has-text-danger"
                        @click="deleteFaq(item)">
                            <b-icon icon="trash"></b-icon>
                            Delete
                        </a>
                    </b-field>

                    <b-field label="Pregunta">
                        <b-input 
                        v-model="item.question"
                        maxlength="80"
                        @input="updateFaqs(item)"
                        > 
                        </b-input>
                    </b-field>
                    <b-field label="Respuesta">
                        <b-input
                        v-model="item.answer"
                        type="textarea"
                        @input="updateFaqs(item)">
                        </b-input>
                    </b-field>
                </div>
                
            </div>
        </div>
        <div v-if="!faqs.length" class="column is-full has-text-centered">
            <p class="title">Agrega preguntas frequentes</p>
            <p>Resolve dudas que le pueden surgir a tus clientes, sin necesidad de contestarles.</p>
        </div>
        <div class="column is-full has-text-centered">
            <b-button
            rounded
            @click="createModalActive=true"
            type="is-primary"
            >
                <b-icon icon="plus" size="is-small" class="m-l-5"></b-icon>
                Agregar una pregunta.
            </b-button>
        </div>
        <b-modal :active.sync="createModalActive" scroll="keep">
            <div class="modal-card" style="width: auto">

                <div class="modal-card-body">
                    <div class="columns is-multiline">
                        <div class="column is-half">
                            <b-field label="Pregunta">
                                <b-input
                                expanded
                                required
                                v-model="newFaq.question">
                                </b-input>
                            </b-field>
                        </div>
                        
                        
                        <div class="column is-full">
                            <b-field label="Respuesta">
                                <b-input
                                type="textarea"
                                v-model="newFaq.answer">
                                </b-input>
                            </b-field>
                        </div>
                        
                        <div class="column is-full has-text-centered">
                            <b-button
                            type="is-primary"
                            rounded
                            :loading="loadingCreate"
                            @click="createFaqs">
                                <b-icon icon="save" size="is-small"></b-icon>
                                Guardar pregunta.
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { postHandler, patchHandler, debounce, deleteHandler, getHandler} from '../../../services/http'
export default {
    props:{
        faqsCreateUrl:{
            type:String,
            default:""
        },
        faqsEditUrl:{
            type:String,
            default:""
        },
        basicUrl:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            faqs:[],
            loading:false,
            createModalActive:false,
            newFaq:{question:"", answer:""},
            loadingCreate:false,
            info:{}
        }
    },
    methods:{
        async fetchFaqs(){
            this.loading = true
            this.faqs = await getHandler(this.faqsCreateUrl, {error:false, success:false})
            this.loading = false
        },

        async fetchDetails(){
            this.loading = true
            let resp = await getHandler(this.basicUrl, {error:false, success:false})
            this.info = resp
            this.loading = false
        },

        editBasicInfo: debounce(
                async function (){
                var msg = {
                    resource:'notify'
                }
                var resp = await patchHandler(this.basicUrl, this.info, {error:msg, success:msg})
                this.fetchDetails()
            },
            700
        ),

        async createFaqs(){
            var msg = {
                resource:'notify',
            }
            this.loadingCreate = true
            var resp = await postHandler(this.faqsCreateUrl, this.newFaq, {error:msg, success:msg})
            this.loadingCreate = false
            this.newFaqs = {question:"", answer:""}
            this.createModalActive = false
            this.fetchFaqs()
        },
        async deleteFaq(item){
            var msg = {
                resource:'notify',
            }
            var url = this.faqsEditUrl.replace('0000', item.id)
            var resp = await deleteHandler(url, {error:msg, success:msg})
            this.fetchFaqs()
        },
        updateFaqs: debounce(
                async function (item){
                var msg = {
                    resource:'notify'
                }
                var url = this.faqsEditUrl.replace('0000', item.id)
                var resp = await patchHandler(url, item, {error:msg, success:msg})
                this.fetchFaqs()
            },
            700
        ),
    },
    created(){
        this.fetchFaqs()
        this.fetchDetails()
    }
}
</script>

<style lang="scss" scoped>

</style>